/* eslint-disable no-param-reassign */
import React, { Component } from 'react'
import moment from 'moment'
import { DatePicker } from 'antd'
import './index.less'

const FORMAT = 'YYYY-MM-DD'
function getCalendarContainer(trigger) {
  return trigger.parentNode
}
const defaultConfig = {
  open: true,
  showToday: false,
  dropdownClassName: 'daypick-item-content',
  getCalendarContainer
}
export default class DayPicker extends Component {
  static defaultProps = {
    value: []
  }

  onChange = (data, str) => {
    const v = []
    if (data instanceof moment) {
      v.push(data.format(FORMAT))
      v.push(data.format(FORMAT))
      data = v
    }
    this.props.onChange(data, str)
  }

  dateRender(current) {
    const style = {}
    let p = null
    if (this.props.tipDates.includes(current.format('YYYY-MM-DD'))) {
      style.position = 'relative'
      p = <div style={{ width: 3, height: 3, backgroundColor: '#f55', borderRadius: '50%', position: 'absolute', top: 0, right: 0 }} />
    }
    return (
      <div className="ant-calendar-date" style={style}>
        {p}
        {current.date()}
      </div>
    )
  }

  disabledDate(currentDate) {
    const earlistDate = moment(this.props.earlistDate)
    let before = earlistDate
    if (this.props.accountInfo.userAuthCodeList.some(m => m === 'history_no_limit')) {
      before = earlistDate
    } else if (this.props.accountInfo.userAuthCodeList.some(m => m === 'history_two_year')) {
      before = moment.max(before, moment().subtract(2, 'year').startOf('D')).subtract(1, 'quarter').startOf('quarter')
    } else if (this.props.accountInfo.userAuthCodeList.some(m => m === 'history_one_year')) {
      before = moment.max(before, moment().subtract(1, 'year').startOf('D')).subtract(1, 'quarter').startOf('quarter')
    } else if (this.props.accountInfo.userAuthCodeList.some(m => m === 'history_six_month')) {
      before = moment.max(before, moment().subtract(6, 'month').startOf('D')).subtract(1, 'quarter').startOf('quarter')
    }
    return moment.isMoment(currentDate) && (currentDate.isBefore(before)
    || currentDate.isAfter(moment().subtract(1, 'day').endOf('day')))
  }

  render() {
    const { value, dateRender } = this.props
    return (
      <div>
        <DatePicker
          dateRender={dateRender || this.dateRender.bind(this)}
          disabledDate={this.disabledDate.bind(this)}
          onChange={this.onChange.bind(this)}
          value={moment(value[0])}
          {...defaultConfig}
        />
      </div>
    )
  }
}
